import DateListViewer from '@/shared/components/DateListViewer/DateListViewer.vue';
import { start } from 'repl';
import FaskhVerificationComponent from '@/shared/components/FaskhVerificationComponent/FaskhVerificationComponent';
import '@babel/polyfill';
import Vue from 'vue';
// import './plugins/vuetify';
// import Vuetify from 'vuetify';
import vuetify from './plugins/vuetify';
import 'vuetify/dist/vuetify.min.css';
import i18n from '@/plugins/i18n';
import App from './components/App/App';
import router from './router';
import './registerServiceWorker';
import { VueDiContainer } from 'vue-di-container';
import AxiosService from './services/AxiosService';
import LoaderService from './services/LoaderService';
import initializeApplication from './plugins/application-initialization';
import RecaptchaService from './services/RecaptchaService';
import { Toaster } from './services/toast';
import Fragment from 'vue-fragment';
import store from './Store/Store';
import { TelemetryService } from './services/TelemetryService';
import surveyview from '@t2/QaimPackage';
import '@t2/QaimPackage/dist/surveyview.css';
import {
  ValidationProvider,
  extend,
  configure,
  ValidationObserver,
  localize,
} from 'vee-validate';
import { required, email, min } from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import ar from 'vee-validate/dist/locale/ar.json';

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import DataCustomLabelViewer from './shared/components/DataCustomLabelViewer/DataCustomLabelViewer';
import NafathNumberChallenge from './components/shared/NafathNumberChallenge.vue';
import * as _loadash from "lodash";


localize({
  en,
  ar,
});
localize('ar');
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid',
    dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
  },
});

//#region ValidationRules
extend('required', {
  ...required,
  // message: '{_field_} هذا الحقل مطلوب',

  message: (_, values) => i18n.tc('validation.required'),
});

extend('required_if', {
  ...required,
  // message: '{_field_} هذا الحقل مطلوب',

  message: (_, values) => i18n.tc('validation.required'),
});

extend('requiredNumber', {
  ...required,
  validate: (value) => {
    return value !== -1 && value !== 0 && value !== undefined;
  },
  message: (_, values) => i18n.tc('validation.required'),
});

extend('email', email);

// Wekalat Mobile ValidationRules

const startsWithCustomRule = (value: any, { start }: any = {}) => {
  return value.startsWith(start);
};
const startsWithCustomRuleparamNames = ['start'];

extend('startsWithCustomRule', {
  params: ['start'],
  validate: (value, { start }: any) => {
    const starts = Array.isArray(start) ? start : [start];
    return starts.some(prefix => value.startsWith(prefix));
  },
  message: (feildName, values) => {
    const starts = Array.isArray(values.start) ? values.start : [values.start];
    return i18n.t('validation.mobilestartWith05', {
      _field_: feildName,
      start: _loadash.join(starts, ' أو ')
    }).toString()
  }
});

// extend('startWith05', {
//   validate: (value) => {
//     return value.startsWith('05');
//   },
//   message: (_, values) => i18n.tc('validation.mobilestartWith05')
// });

extend('minLength',
  {
    ...min,
    message: (feildName, values) => {
      return i18n.t('validation.minLength', { length: values.length, _field_: feildName }).toString();
    }
  });



//#endregion



export const bus = new Vue();

Vue.config.productionTip = false;
Vue.use(VueDiContainer);
Vue.component('surveyview', surveyview);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

Vue.component('FaskhVerificationComponent', FaskhVerificationComponent);

Vue.component('VuePhoneNumberInput', VuePhoneNumberInput);

Vue.component('VueTelInput', VueTelInput);

Vue.component('DataCustomLabelViewer', DataCustomLabelViewer);
Vue.component('DateListViewer', DateListViewer);

Vue.component('NafathNumberChallenge', NafathNumberChallenge);
// Vue.use(Vuetify);

Vue.filter('two_digits', function (value: any) {
  if (value.toString().length <= 1) {
    return '0' + value.toString();
  }
  return value.toString();
});

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    window.location.href = '/NotFound';
  } else {
    next();
  }
});
Vue.use(Fragment.Plugin);

declare module 'vue/types/vue' {
  interface Vue {
    $appInsights: any;
    $appConfig: any;
    $user: any;
  }
}

declare global {
  interface Window {
    ShowLoader(): void;
    HideLoader(): void;
    Landing(): void;
  }
}

initializeApplication().then((initialize) => {
  new Vue({
    i18n,
    router,
    vuetify,
    store,
    diProvide: [
      AxiosService,
      LoaderService,
      RecaptchaService,
      Toaster,
      TelemetryService,
    ],
    render: (h) => h(App),
  }).$mount('#app');
});
